/**
 * @owner @Appboy/intelligence
 */

import { hasImageComponent } from "./hasImageComponent";
import { isRcsImageEligibleMessageShape } from "./isRcsImageEligibleMessageShape";
import type { ComponentStoreData, ContentOptimizationSmsMessage } from "./types";

/**
 * Whether to show the Image-component delete confirmation before applying an SMS update.
 * Returns true when the message shape loses Image-component eligibility (subscription group / protocol / RCS type).
 */
export const shouldShowDeleteImageComponentConfirmationModal = (
  componentStoreData: ComponentStoreData,
  currentMessage: ContentOptimizationSmsMessage,
  nextMessage: ContentOptimizationSmsMessage
): boolean => {
  return (
    hasImageComponent(componentStoreData) &&
    isRcsImageEligibleMessageShape(currentMessage) &&
    !isRcsImageEligibleMessageShape(nextMessage)
  );
};
